import { FLIGHT_PRODUCTS_REQUEST, FLIGHT_PRODUCTS_SUCCESS, FLIGHT_PRODUCTS_ERROR } from './types';

const initialState = {
  data   : [],
  loading: false,
  error  : null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FLIGHT_PRODUCTS_REQUEST:
      return {
        ...state,
        error  : null,
        loading: true,
      };
    case FLIGHT_PRODUCTS_SUCCESS:
      return {
        ...state,
        data   : action.data,
        loading: false,
      };
    case FLIGHT_PRODUCTS_ERROR:
      return {
        ...state,
        error  : action.error,
        loading: false,
      };
    default:
      return state;
  }
}
